var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"deptMngTable",attrs:{"pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"paging":"","columns":_vm.columns,"rows":_vm.rows,"fit":"fit","height":"50vh","stripe":false},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }